export default __webpack_public_path__ + "static/media/GoogleIcon.0590aaf0.png";